<template>
  <div class="flex flex-col h-full">
    <div class="px-4 py-2.5 bg-white flex items-center gap-3" style="border-bottom: 1px solid #E8E9E9;">
      <h2 class="text-lg font-semibold" style="color: #353537;">Operations V2</h2>
    </div>

    <div style="border-bottom: 1px solid #E8E9E9;">
      <div class="px-4 pt-3 pb-1 flex items-baseline gap-3">
        <span class="text-sm font-semibold" style="color: #353537;">Work completed, worked gaps and worked gaps closed, by week</span>
        <span class="text-xs" style="color: #A5A5A6;">
          last {{ trend ? trend.length : 26 }} complete weeks &middot; Care Gap MRR, Care Gap Patient Call and Care Gap Action Outcome only; deleted work excluded
          &middot; cumulative lines are running totals from the first week shown; a worked gap counts in the week it was first worked, and as closed in the week of the first payer report after the work that shows it compliant
        </span>
      </div>
      <div class="px-2 pb-2">
        <LoadingIndicator v-if="loading" />
        <div v-else-if="error" class="px-2 py-6 text-sm" style="color: #B91C1C;">{{ error }}</div>
        <div v-else-if="!trend || !trend.some(w => w.work_count)" class="px-2 py-6 text-sm" style="color: #626264;">
          No work logged in this window.
        </div>
        <Chart_V5 v-else :chart_data="trendChart" :chart_config="trendConfig" override-height="h-[320px]" />
      </div>
    </div>
  </div>
</template>

<script>
import Chart_V5 from '@/components/widgetcomponents/Viz_Elements/Chart_V5.vue';
import LoadingIndicator from '@/components/widgetcomponents/library/LoadingIndicator.vue';

export default {
  name: 'Quality_Operations_V2',
  components: { Chart_V5, LoadingIndicator },

  data() {
    return {
      trend: null,
      loading: false,
      error: null,
    };
  },

  computed: {
    cumulativeWorked() {
      let total = 0;
      return this.trend.map(w => (total += w.gaps_first_worked));
    },
    cumulativeClosed() {
      let total = 0;
      return this.trend.map(w => (total += w.worked_gaps_closed));
    },
    trendChart() {
      return {
        labels: this.trend.map(w => w.week),
        series: [
          {
            values: this.trend.map(w => w.work_count),
            config: {
              label: 'Work completed (right axis)',
              backgroundColor: '#21426C',
              type: 'line',
              yAxis: 'right',
              offset: 0,
            },
          },
          {
            values: this.cumulativeWorked,
            config: {
              label: 'Worked gaps (cumulative)',
              backgroundColor: '#F76734',
              type: 'line',
              yAxis: 'left',
              offset: 0,
            },
          },
          {
            values: this.cumulativeClosed,
            config: {
              label: 'Worked gaps closed (cumulative)',
              backgroundColor: '#389A6C',
              type: 'line',
              yAxis: 'left',
              offset: 0,
            },
          },
        ],
      };
    },
    trendConfig() {
      return {
        chartType: 'vertical_bar',
        margin: { top: 60, right: 70, bottom: 70, left: 60 },
        xAxis: { labelRotation: -45, fontSize: 11 },
        yAxes: [
          { position: 'left', min: 0, max: null, fontSize: 11 },
          { position: 'right', min: 0, max: null, fontSize: 11 },
        ],
        legend: { display: true, position: 'top', spacing: 15 },
        formatting: { percentage: false, currency: false, sig_figs: 0 },
        labelDisplayConfig: { minLabelSpacing: 1, labelFontSize: 11 },
      };
    },
  },

  mounted() {
    this.fetchTrend();
  },

  methods: {
    async fetchTrend() {
      this.loading = true;
      this.error = null;
      try {
        const { data } = await this.$axios.get('/api/quality/operations/', { params: { lookup: 'weekly_trend' } });
        this.trend = data.trend;
      } catch (e) {
        this.error = e?.response?.data?.error || 'Could not load work trend.';
        this.trend = null;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
